var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-200 -200 711 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.4,
    filter: "url(#filter0_f_4015_9637)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.6065 468.363C205.864 542.571 204.787 614.447 190.091 641.11C161.531 693.876 191.553 788.311 255.592 802.759C319.631 817.207 417.864 813.647 451.319 730.101C484.775 646.554 421.471 557.354 339.47 403.033C257.468 248.712 310.949 221.282 273.51 130.407C236.071 39.5316 -1.44667 23.1991 -36.363 130.407C-71.2792 237.615 -48.965 375.603 92.6065 468.363Z",
    fill: "url(#paint0_linear_4015_9637)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6065 468.363C205.864 542.571 204.787 614.447 190.091 641.11C161.531 693.876 191.553 788.311 255.592 802.759C319.631 817.207 417.864 813.647 451.319 730.101C484.775 646.554 421.471 557.354 339.47 403.033C257.468 248.712 310.949 221.282 273.51 130.407C236.071 39.5316 -1.44667 23.1991 -36.363 130.407C-71.2792 237.615 -48.965 375.603 92.6065 468.363Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4015_9637",
    x: -301.422,
    y: -194.489,
    width: 1012.38,
    height: 1254.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_4015_9637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4015_9637",
    x1: -104.8,
    y1: 208.697,
    x2: 398.101,
    y2: 224.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5BB099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336268,
    stopColor: "#67D2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632216,
    stopColor: "#3D78D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81533,
    stopColor: "#212477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg1);
export default __webpack_public_path__ + "static/media/login-bg-1.eded8480093d0b4106192aa1b61f0eef.svg";
export { ForwardRef as ReactComponent };